var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessToastIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "71px",
    viewBox: "0 0 71 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A1F2C604-6948-4AB6-B201-8A86A964C9AB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25.5,
    cy: 25.5,
    r: 25.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.4%",
    y: "-29.4%",
    width: "158.8%",
    height: "158.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0523374331 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-A-new-team-save",
    transform: "translate(-1780.000000, -83.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "success",
    transform: "translate(1499.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mark",
    transform: "translate(291.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.5674743,16.2256309 C34.1958773,17.4201442 32.9349357,18.6808569 31.673836,19.9858475 C30.434978,21.290996 29.2181642,22.6180662 28.0456362,23.9894142 C26.320029,26.0464165 24.6607913,28.1920534 23.1121695,30.4039687 L17.4928844,24.3654398 C17.2274538,24.0778435 16.785022,23.989434 16.4310118,24.2105307 C16.0106321,24.4538493 15.8779326,24.9847801 16.1212953,25.404886 C16.1212953,25.404886 21.4751023,34.628573 21.696334,35.0267178 C21.9176289,35.4027236 22.4043545,36 23.3998576,36 C24.3733165,36 24.9041541,35.4249415 25.2140365,34.8276849 C25.5458208,34.2083486 28.5104282,28.7227985 30.4351045,25.8251894 C31.3863217,24.3652858 32.4261107,22.94966 33.4659392,21.5561928 C34.5278118,20.1626467 35.6339703,18.7912986 36.7623309,17.5083877 L36.7843984,17.4863243 C37.0718929,17.1103184 37.0718929,16.6236773 36.7842441,16.291811 C36.4745717,15.9380345 35.9214846,15.8939107 35.5674743,16.2256309 Z",
    id: "Path",
    fill: "#023B93",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessToastIcon);
export default __webpack_public_path__ + "static/media/success-toast-icon.2bae124e307f5adb7d89c71f357323a9.svg";
export { ForwardRef as ReactComponent };